import { createSelector } from 'reselect';
import orderBy from 'lodash.orderby';
import Dealer from '@app/models/Dealer';

const getDealers = ({ dealer }) => dealer.all;

const getFilteredDealers = ({ dealer }) => dealer.filteredAll;

const getDealersSortedByNameAndEnabledStatus = createSelector(getFilteredDealers, dealers =>
  orderBy(dealers, ['isEnabled', 'name'], ['desc', 'asc']),
);

const getMainShopDealersSortedByNameAndEnabledStatus = createSelector(
  getDealersSortedByNameAndEnabledStatus,
  dealers => dealers.filter(dealer => Dealer.isMainshop(dealer.id)),
);

export default {
  getDealers,
  getFilteredDealers,
  getDealersSortedByNameAndEnabledStatus,
  getMainShopDealersSortedByNameAndEnabledStatus,
};



// WEBPACK FOOTER //
// ./src/selectors/dealerSelectors.js